var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"left"}},[_c('h4',{staticStyle:{"padding":"0 20px 0 20px"}},[_vm._v("\n   To be updated.\n  ")]),_vm._v(" "),_c('full-calendar',{attrs:{"events":_vm.fcEvents,"locale":"en"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b62c4e6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/Resources.vue
// module id = NwSN
// module chunks = 1